import msalInstance, { ensureMsalInitialized, getPreferredAccount } from "../app/auth/msalInstance";

const apiScope = process.env.REACT_APP_B2C_API_SCOPE;

const acquireToken = async () => {
  await ensureMsalInitialized();
  let account = getPreferredAccount();
  if (!account) {
    throw new Error("No active account for token acquisition");
  }

  try {
    const response = await msalInstance.acquireTokenSilent({ scopes: [apiScope], account });
    return response.accessToken;
  } catch (err) {
    if (err?.errorCode === "authority_mismatch") {
      // Force an interactive login with the configured authority to reconcile the account.
      await msalInstance.loginRedirect({ scopes: [apiScope] });
    }
    throw err;
  }
};

export const adalApiFetch = async (fetchFn, url, options) => {
  const token = await acquireToken();
  const effectiveFetch = fetchFn || fetch;
  const effectiveOptions = options || {};
  const headers = new Headers(effectiveOptions.headers || {});
  headers.set("Authorization", `Bearer ${token}`);
  return effectiveFetch(url, { ...effectiveOptions, headers });
};

export const MSALinstance = msalInstance;

// Back-compat helpers used by portal code; no-ops or pass-through for now.
export const RequestAPIData = async (uri, options) => {
  const token = await acquireToken();
  const headers = new Headers(options?.headers || {});
  headers.set("Authorization", `Bearer ${token}`);
  return fetch(uri, { ...(options || {}), headers });
};

// Back-compat: mimic portal userInfo shape
export const userInfo = () => {
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  return account ? { ...account, userName: account.username } : null;
};
